import AppHeader from "@/components/AppHeader";

export default {
  name: "accident-history-edit",
  components: {
    AppHeader
  },
  async created() {
    await this.getAccidentHistory();
    this.getTodayDate();
    await this.getUser();
  },
  data() {
    return {
      canChoiceYears: [],
      dayCount: "",
      changeYear: "",
      changeMonth: "",
      changeDay: "",
      accidentHistory: {
        user_id: "",
        change_date: "",
        content: ""
      },
      user: ""
    };
  },
  computed: {
    changeDateFormat() {
      return this.changeYear + "-" + this.changeMonth + "-" + this.changeDay;
    }
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.accidentHistory.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let i = 0; i < 60; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
      this.dayCount = new Date(this.changeMonth, this.changeDay, 0).getDate();
    },
    async getAccidentHistory() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_ACCIDENT_HISTORY", {
          id: this.$route.params.accident_history_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.accidentHistory.user_id = res.accident_history.user_id;
      this.changeYear = parseInt(res.accident_history.change_date.substr(0, 4));
      this.changeMonth = parseInt(
        res.accident_history.change_date.substr(5, 2)
      );
      this.changeDay = parseInt(res.accident_history.change_date.substr(8, 2));
      this.accidentHistory.content = res.accident_history.content;
    },
    async editAccidentHistory() {
      this.accidentHistory.change_date = this.changeDateFormat;
      let data = this.accidentHistory;
      let res = await this.$store
        .dispatch("EDIT_ACCIDENT_HISTORY", {
          id: this.$route.params.accident_history_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goAccidentHistory();
      }
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.accidentHistory.user_id}` });
    },
    goAccidentHistory() {
      this.$router.push({
        path: `/accident_history/${this.accidentHistory.user_id}`
      });
    },
    getDayCount() {
      this.changeDay = "";
      this.dayCount = new Date(this.changeYear, this.changeMonth, 0).getDate();
    }
  }
};
